import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const focaccia: Recipe = {
  slug: 'focaccia',
  title: 'Focaccia',
  category: 'salé',
  description: 'Un pain plat italien à étaler dans une plaque de 30 × 40 cm.',
  image: image('focaccia'),
  tags: ['pain', 'levée', 'plaque'],
  meta: [
    { label: 'Préparation', value: '15 à 30 min, plus les levées' },
    { label: 'Cuisson', value: '20 min à 225 °C' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('farine', 'farine', '500 g de farine', { amount: 500, unit: 'g', shoppingKey: 'farine' }),
      ingredient('eau', 'eau', '380 g d’eau', { amount: 380, unit: 'g', shoppingKey: 'eau' }),
      ingredient('levure', 'levure sèche', '5 g de levure sèche', {
        amount: 5,
        unit: 'g',
        shoppingKey: 'levure sèche',
      }),
      ingredient('sel', 'sel', '10 g de sel', { amount: 10, unit: 'g', shoppingKey: 'sel' }),
      ingredient('huile', 'huile d’olive', '40 g d’huile d’olive', {
        amount: 40,
        unit: 'g',
        shoppingKey: 'huile d’olive',
      }),
    ]),
  ],
  steps: [
    'Réunir tous les ingrédients dans le bol du KitchenAid et pétrir au crochet jusqu’à ce que la pâte se décolle des parois.',
    'Si la pâte reste collante, la laisser reposer 15 minutes, faire quelques rabats, puis recommencer après 30 minutes.',
    'Laisser lever 3 à 4 heures directement sur la plaque bien huilée (30 × 40 cm), en couvrant.',
    'Étaler et façonner à la main après avoir badigeonné d’huile d’olive ; parsemer de romarin ou d’origan et d’une pincée de fleur de sel.',
    'Cuire 20 minutes à 225 °C (chaleur tournante).',
  ],
  note: 'Pour donner plus de force à la pâte, on peut d’abord la laisser lever dans le bol 2 à 3 heures en procédant aux mêmes rabats, puis la transférer sur la tôle huilée pour encore une heure avant de façonner.',
}
